import { getImageUrl } from '~/components/Image/helpers'
import { VIDEO_POSTER_AVATAR_SIZE } from '~/curriculum/constants/videoPoster.const'
import useAvatarImageUrl from '~/dashboard/hooks/useAvatarImageUrl'

/** Title + avatar over a video poster. DOM, not canvas, so the title stays real text. */
export default function VideoPosterOverlay({
  title = '',
  isCompact = false,
}: {
  title?: string
  /** Scales the headline down for small previews, e.g. the Oracle chat card. */
  isCompact?: boolean
}): React.ReactElement {
  const { url: avatarUrl, isExists, isUnder13 } = useAvatarImageUrl()

  // ReadyPlayerMe renders are ready-made CDN PNGs; under-13 and default are bucket keys.
  const avatarSrc =
    isUnder13 || !isExists
      ? getImageUrl(VIDEO_POSTER_AVATAR_SIZE, VIDEO_POSTER_AVATAR_SIZE, 'contain', avatarUrl, undefined, {
          hex: '#000000',
          alpha: 0,
        }).urlWithFormat
      : avatarUrl

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-5" data-test-id="video-poster-overlay">
      {/* `!my-0` defeats `.sanity-block img { my-9 }`. The default avatar is unlit, so it gets a lift. */}
      <img
        alt=""
        className={`absolute bottom-0 left-0 h-5/6 w-auto !my-0 ${isExists ? '' : 'brightness-125'}`}
        src={avatarSrc}
      />
      {/* `span`, not `p` — `.curriculum-video-page p` would win on specificity. */}
      {title.length > 0 && (
        <span
          className={`absolute inset-x-0 top-0 mx-auto block w-11/12 font-black text-white text-center leading-none uppercase line-clamp-3 ${
            isCompact ? 'pt-2 text-3' : 'pt-4 md:pt-6 text-md md:text-h3'
          }`}
        >
          {title}
        </span>
      )}
    </div>
  )
}
